/**
 * Small helpers for assembling report/label text without leaving behind
 * placeholder tokens (e.g. '[zip]') or dangling punctuation when the
 * underlying value is missing. Used across the Magic Report export/template
 * builders so a missing field renders as nothing instead of bracketed
 * placeholder text.
 */

/** Returns the trimmed string value, or '' if it's missing/blank. */
export const orEmpty = (value?: string | number | null): string => {
  if (value === null || value === undefined) return '';
  const str = String(value).trim();
  return str;
};

/** Joins only the non-empty parts with the given separator (default ', '). */
export const joinNonEmpty = (parts: Array<string | undefined | null>, sep = ', '): string => {
  return parts
    .map(part => (part ?? '').toString().trim())
    .filter(Boolean)
    .join(sep);
};

/** Returns "name's", or '' if name is empty. */
export const possessive = (name?: string | null): string => {
  const trimmed = orEmpty(name);
  return trimmed ? `${trimmed}'s` : '';
};

/**
 * Returns "label{sep}value" (sep defaults to ': '), or '' if value is empty —
 * dropping the whole labeled fragment rather than leaving a dangling label.
 */
export const labelValue = (label: string, value?: string | number | null, opts?: { sep?: string }): string => {
  const trimmed = orEmpty(value);
  if (!trimmed) return '';
  const sep = opts?.sep ?? ': ';
  return `${label}${sep}${trimmed}`;
};
